import PrivateRoute from '@Components/ConditionalRoutes/PrivateRoute';
import PublicOnlyRoute from '@Components/ConditionalRoutes/PublicOnlyRoute';
import RouteErrorBoundary from '@Components/ErrorBoundary/RouteErrorBoundary';
import LoginAsStudent from '@Components/UI/Iframes/LoginAsStudent/LoginAsStudent';
import { useTypedSelector } from '@Features/store';
import Login from '@Pages/Login';
import { RouteProvider } from '@Providers/Routes/RoutesProvider';
import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { urlToHttpOptions } from 'url';
import DashboardLayout from './DashboardLayout';

const RoutesLayout = () => {
	const { isAuth } = useTypedSelector((state) => state.auth);
	const location = useLocation();
	return (
		// No Router here: App.tsx already provides <Router history={history}>.
		// Nesting a second <BrowserRouter> gave it a separate history instance,
		// so Layout's useLocation/useHistory and the routes below were driven by
		// two different sources - and any programmatic push on the outer history
		// changed the URL without re-matching these routes.
		<RouteErrorBoundary resetKey={location.pathname}>
			<Switch>
				<Route exact path={'/'}>
					{/* Authenticated visitors previously redirected to `pathname`,
					    which at "/" is "/" - a no-op that rendered a blank page. */}
					{isAuth ? <Redirect to="/dashboard" /> : <Redirect to="/login" />}
				</Route>
				<PublicOnlyRoute path={'/login'} render={() => <Login />} />
				<Route path={'/student/:id'} component={LoginAsStudent} />
				<PrivateRoute path={'/dashboard'}>
					<DashboardLayout />
				</PrivateRoute>
			</Switch>
		</RouteErrorBoundary>
	);
};

export default RoutesLayout;
